module.exports = __webpack_public_path__ + "static/img/elebits_uw_port_lg.bc9c690.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/elebits-underwater-game-development/elebits_uw_port_lg.jpg
// module id = 235
// module chunks = 2